import React from 'react';

const SectionCard = ({ title, children, rightHeaderContent }) => {
  return (
    <section className="Summary_auto_second_header">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="Summary_auto_second_header_title">{title}</div>
        {rightHeaderContent && <div className="Summary_auto_second_header_right_content">{rightHeaderContent}</div>}
      </div>
      {children}
    </section>
  );
};

export default SectionCard; 